/**
 * Implements mobile chain page placeholder
 */
import {
  AboutPlaceholder,
  PairsTablePlaceholder,
} from '../../../../components/SEO/mobile/Placeholder';

import '../../../../components/SEO/mobile/styles.scss';

const ChainPageMobilePlaceholder = () => {
  return (
    <div className='mobile_seo_page__content'>
      <AboutPlaceholder count={3} />
      <PairsTablePlaceholder />
    </div>
  );
};

export default ChainPageMobilePlaceholder;
